import React, { ReactElement, SVGProps } from 'react';

export function AnimationBase (props: SVGProps<SVGElement>): ReactElement {
    return (
        <animate
            repeatCount="indefinite"
            dur="3.571428571428571s"
            keyTimes="0;1"
            keySplines="0 0.2 0.8 1"
            calcMode="spline"
            {...props}
        />
    );
}
